var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceForecastNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53977 0.491211C3.51262 6.46044 0.456055 7.66303 0.456055 11.848C0.456055 13.9477 2.53195 15.4912 4.53977 15.4912C6.59297 15.4912 8.54324 14.0479 8.54324 12.0544C8.54324 8.03714 5.60124 6.44937 4.53977 0.491211ZM2.52697 7.989C1.56124 10.5973 2.35042 13.3262 4.40031 14.1829C4.92495 14.4021 5.49498 14.4497 6.05394 14.3999C2.04383 16.1193 -0.36246 11.6444 2.52697 7.989Z",
    fill: "#9E9E9E",
    stroke: "#9E9E9E",
    strokeWidth: 0.001125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceForecastNavbar);
export default __webpack_public_path__ + "static/media/priceForecastNavbar.bcc2dbe43d3e1b05507ccfe7b2d245ec.svg";
export { ForwardRef as ReactComponent };